import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'
import {
  IBalanceListRes,
  IBalanceListParams,
  IAdjustBalanceParams,
  ITransactionListRes,
  ITransactionListParams,
  IBatchRecordItem,
  IExportTaskRes,
} from './types'

/** 6.1 余额列表查询 */
export const fetchBalanceList = (params: IBalanceListParams) =>
  request.post<IBalanceListRes>(`${HOSTS.BASE}/api/entweb/budget/fee/list`, params)

/** 6.5 余额列表导出 */
export const exportBalanceList = (params: {
  budgetPolicyNo: string
  staffIdList?: number[]
  keyword?: string
}) => request.post<IExportTaskRes>(`${HOSTS.BASE}/api/entweb/budget/fee/export`, params)

/** 6.3 手动余额调整 */
export const adjustBalance = (params: IAdjustBalanceParams) =>
  request.post<void>(`${HOSTS.BASE}/api/entweb/budget/fee/adjust`, params)

/** 批量调整余额（上传文件） */
export const batchAdjustBalance = (params: {
  byteBuffer: Blob
  rulePackageId: string
  fileName?: string
}) =>
  request.post<string>(
    `${HOSTS.BASE}/api/entweb/budget/importData`,
    { ...params, importType: '2' },
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )

/** 批量调整余额模板下载 */
export const fetchBatchAdjustTemplate = (rulePackageId: string) =>
  request.get<{ fileURL?: string; taskToken?: string }>(
    `${HOSTS.BASE}/api/entweb/budget/file/download`,
    { params: { type: 1004, rulePackageId } }
  )

/** 批量调整历史记录 */
export const fetchBatchAdjustRecords = (params: {
  rulePackageId: string
  pageNo: number
  pageSize: number
}) =>
  request.get<{ result: IBatchRecordItem[]; totalCount: number }>(
    `${HOSTS.BASE}/api/entweb/budget/task/adjust/list`,
    { params }
  )

/** 轮询批量任务结果 */
export const fetchBatchAdjustAsyncResult = (token: string) =>
  request.get<{ fileUrl: string }>(
    `${HOSTS.BASE}/api/entweb/budget/queryAsyncResult`,
    { params: { token } }
  )

/** 触发批量调整费用生效（轮询成功后调用，调用成功才真正生效） */
export const triggerBatchAdjustFee = (params: {
  budgetPolicyNo: string
  rulePackId: string
  token: string
}) =>
  request.post<{ success: boolean }>(
    `${HOSTS.BASE}/api/entweb/budget/trigger/update/fee`,
    params
  )

/** 6.2 交易明细查询 */
export const fetchTransactionDetails = (params: ITransactionListParams) =>
  request.post<ITransactionListRes>(
    `${HOSTS.BASE}/api/entweb/budget/record/list`,
    params
  )

/** 6.4 交易明细导出 */
export const exportTransactionDetails = (params: {
  budgetPolicyNo: string
  budgetFeeId?: number
  keyword?: string
  startTime?: number
  endTime?: number
  actionTypeList?: number[]
}) =>
  request.post<IExportTaskRes>(
    `${HOSTS.BASE}/api/entweb/budget/record/export`,
    params
  )
